// extracted by mini-css-extract-plugin
module.exports = {"header":"index-module_header_25qEt","header__safe-area":"index-module_header__safe-area_2QoW0","header_fixed":"index-module_header_fixed_1JrIZ"};